import { render, staticRenderFns } from "./issueMy.vue?vue&type=template&id=d4be9090&scoped=true"
import script from "./issueMy.vue?vue&type=script&lang=js"
export * from "./issueMy.vue?vue&type=script&lang=js"
import style0 from "./issueMy.vue?vue&type=style&index=0&id=d4be9090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4be9090",
  null
  
)

export default component.exports